import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const CustomReportSqlDraftStatusSchema = z.enum([
  "ready",
  "unavailable",
  "failed",
]);

export const draftCustomReportAstFromSql = unaryRpc({
  name: "draftCustomReportAstFromSql" as const,
  description:
    "Draft a custom analytics semantic query AST from hand-written Snowflake SQL by prompting the custom analytics agent and re-prompting with the compiler error until it compiles. The result is a proposal that still must be validated, previewed, and compared against the source SQL.",
  input: z.object({
    sql: z.string().trim().min(1).max(20_000),
    teamId: z.string().trim().min(1),
    notes: z.string().trim().max(4000).nullable().default(null),
    maxAttempts: z.number().int().min(1).max(5).default(3),
  }),
  output: z.object({
    status: CustomReportSqlDraftStatusSchema,
    ast: z.unknown().nullable(),
    title: z.string().nullable(),
    explanation: z.string().nullable(),
    missingConcepts: z.array(z.string()),
    error: z.string().nullable(),
  }),
});

export type DraftCustomReportAstFromSqlInput = z.infer<
  typeof draftCustomReportAstFromSql.input
>;
export type DraftCustomReportAstFromSqlOutput = z.infer<
  typeof draftCustomReportAstFromSql.output
>;
